import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { base_url } from '../../Api/Api';
import Pagination from '@material-ui/lab/Pagination';
import Courses from '../Courses';
import ItemCourseSkltn from './ItemCourseSkltn';

const MyCoursesProfile = (props) => {

    const [state, setState] = useState({
        data: [],
        statusCards: false,
        minPaginate: 0,
        maxPaginate: 9,
        countPaginate: 0,
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`my_courses`)
            .then(response => {
                let tempData = response.data.courses
                let countPaginate = Math.ceil(tempData.length / 9);
                setState({
                    ...state,
                    data: tempData,
                    statusCards: response.data.courses.length == 0,
                    countPaginate: countPaginate
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleChange = (event, value) => {
        setTimeout(() => {
            window.scrollTo(0, 80)
        }, 100);
        setState({
            ...state,
            minPaginate: (value * 9) - 10 <= 0 ? 0 : (value * 9) - 10,
            maxPaginate: (value * 9) - 1 <= 8 ? 9 : (value * 9) - 1
        })
    };

    return (
        <div className="MyCourses-profile">
            <div className="contain">
                <div className="head-course">
                    <h4>کورس های من</h4>
                    <Button
                        variant="contained"
                        onClick={() => props.history.goBack()} >بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></Button>
                </div>
                <div className="courses-list">
                    {state.data.length == 0 ?
                        state.statusCards ?
                            <span className="no-content">اطلاعاتی وجود ندارد</span>
                            :
                            <ItemCourseSkltn
                                count={9} />
                        :
                        state.data.slice(state.minPaginate, state.maxPaginate).map((info, index) =>
                            <Courses
                                key={info.id}
                                data={info} />
                        )
                    }
                    {state.data.length <= 9 ? null :
                        <Pagination
                            count={state.countPaginate}
                            onChange={handleChange} />
                    }
                </div>
            </div>
        </div>
    );
}

export default MyCoursesProfile;